var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_c('iframe',{attrs:{"id":"footer","src":_vm.standaloneFooterUrl,"width":"100%","height":"58px","seamless":"seamless","frameborder":"0","scrolling":"no"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }